import { render, staticRenderFns } from "./TablaCampanias.vue?vue&type=template&id=04e9b8fc"
import script from "./TablaCampanias.vue?vue&type=script&lang=js"
export * from "./TablaCampanias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports